// Indique e ganhe no aparelho: o código do link /c/CODIGO fica guardado até a pessoa ter conta Google e perfil.
// Aí o App manda uma vez para a API, que confere tudo (conta nova, uma vez por pessoa) e dá o bônus a quem indicou.
import { DIAS_PARA_ACEITAR_INDICACAO } from '@truco6/planos';
import { ErroDaApi, api } from './api.ts';
import type { PerfilConta, Sessao } from './conta.ts';

const CHAVE = 'truco6:indicacao';
const VALIDADE_MS = DIAS_PARA_ACEITAR_INDICACAO * 86_400_000;

export function guardarIndicacao(codigo: string): void {
  try { localStorage.setItem(CHAVE, JSON.stringify({ codigo: codigo.toUpperCase(), em: Date.now() })); } catch { /* sem armazenamento: o convite se perde */ }
}

export function indicacaoGuardada(): string | null {
  try {
    const v = JSON.parse(localStorage.getItem(CHAVE) ?? 'null') as { codigo?: string; em?: number } | null;
    if (v?.codigo && typeof v.em === 'number' && Date.now() - v.em < VALIDADE_MS) return v.codigo;
    localStorage.removeItem(CHAVE);
  } catch { /* nada guardado */ }
  return null;
}

export function esquecerIndicacao(): void {
  try { localStorage.removeItem(CHAVE); } catch { /* nada a fazer */ }
}

// Devolve o apelido de quem indicou quando o convite vale. Recusa definitiva (já indicado, conta antiga,
// o próprio código) apaga o código; falha de rede ou convidado sem Google guarda para a próxima vez.
export async function aceitarIndicacao(s: Sessao, perfil: PerfilConta): Promise<string | null> {
  const codigo = indicacaoGuardada();
  if (!codigo || s.anonimo) return null;
  try {
    const r = await api<{ indicador: string }>(s, 'POST', '/indicacao', { codigo, perfil: { apelido: perfil.apelido, avatar: perfil.avatar } });
    esquecerIndicacao();
    return r.indicador;
  } catch (e) {
    if (e instanceof ErroDaApi && e.status >= 400 && e.status < 500 && e.codigo !== 'convidado') esquecerIndicacao();
    return null;
  }
}
